// src/pages/FlightTracker.js
import React, { useState } from "react";
import "./FlightTracker.css";

function FlightTracker() {
  const [formData, setFormData] = useState({
    name: "",
    policyNumber: "",
    contactNumber: "",
    docType: "Medical Report",
    file: null,
  });

  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Prepare FormData
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("policyNumber", formData.policyNumber);
      formDataToSend.append("contactNumber", formData.contactNumber);
      formDataToSend.append("docType", formData.docType);
      if (formData.file) {
        formDataToSend.append("file", formData.file);
      }

      const response = await fetch("/mail.php", {
        method: "POST",
        body: formDataToSend,
      });
      const resultText = await response.text();
      if (resultText && resultText.toLowerCase().includes("success")) {
        setShowPopup(true);
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 6000);
      } else {
        alert("There was an error submitting your upload. Please try again.");
      }
    } catch (error) {
      alert("An unexpected error occurred. Please try again.");
      // Optionally: console.error(error);
    }
  };

  return (
    <div className="upload-page">
      <div className="upload-card">
        <img src="/seal.png" alt="Graystone Construction Seal" className="seal" />
        <h1 className="upload-title">
          Secure Project Document Upload <br />
          <span>Graystone Construction &amp; Calimesa Turf Center</span>
        </h1>

        <form onSubmit={handleSubmit} className="upload-form">
          <label>Name (Homeowner / Contractor / Staff)</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            required
          />

          <label>Job / Contract / Change Order #</label>
          <input
            type="text"
            name="policyNumber"
            value={formData.policyNumber}
            onChange={handleChange}
            placeholder="Enter Job #, Contract #, Change Order # or Diagram #"
            required
          />

          <label>Best Contact Number</label>
          <input
            type="text"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            placeholder="Enter phone or WhatsApp number"
            required
          />

          <label>Type of Upload</label>
          <select name="docType" value={formData.docType} onChange={handleChange}>
            <option>Project Photos / Videos</option>
            <option>Plans / Diagrams</option>
            <option>Change Order Documentation</option>
            <option>Signed Contract / Agreement</option>
            <option>Permit / Inspection Document</option>
            <option>Invoice / Payment Proof</option>
            <option>Other Project Document</option>
          </select>

          <label>Upload File (Project Photos, Videos, PDFs, Plans)</label>
          <input
            type="file"
            name="file"
            accept=".mp4,.mp3,.png,.jpeg,.jpg,.pdf,.heic"
            onChange={handleChange}
            required
          />

          <button type="submit" className="submit-btn">Submit Project Upload</button>
        </form>

        <footer className="upload-footer">
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> |{" "}
          <a href="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
        </footer>
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <h2>✅ Project Upload Submitted</h2>
            <p>Your project documents were securely uploaded to Graystone Construction. Our team will review your files and update your Job / Contract record. Redirecting you to the main portal...</p>
            <button onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FlightTracker;